export const ROOT = 'priceTotal';

export const UPDATE_PRICE_TOTAL = `${ROOT}/UPDATE_PRICE_TOTAL`;
export const SET_PRICE_TOTAL_BY_CHANNEL = `${ROOT}/SET_PRICE_TOTAL_BY_CHANNEL`;
export const CLEAR_PRICE_TOTAL = `${ROOT}/CLEAR_PRICE_TOTAL`;
